export default __webpack_public_path__ + "static/media/PrizeCupSilver.b2733c0e.png";